var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{staticClass:"action-documents-table bg-default-card",attrs:{"header-tag":"h4","header":_vm.uLang('app.available_reports')}},[_c('generated-reports-table')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }